import apiClient from '@/service/api'

const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api'

class NotificationService {
    /**
     * Get all notifications
     */
    async getNotifications(category = 'inbox', page = 1, perPage = 20) {
        try {
            const response = await apiClient.get('/notifications', {
                params: { category, page, per_page: perPage }
            })
            return response.data
        } catch (error) {
            console.error('Error fetching notifications:', error)
            throw error
        }
    }

    /**
     * Get unread notifications count
     */
    async getUnreadCount() {
        try {
            const response = await apiClient.get('/notifications/unread-count')
            return response.data
        } catch (error) {
            // Polling can overlap a long-running request in local/single-worker
            // environments. The caller keeps the last known count on timeout.
            if (error.code !== 'ECONNABORTED' && error.code !== 'ERR_CANCELED') {
                console.error('Error fetching unread count:', error)
            }
            throw error
        }
    }

    /**
     * Get all notification counts in a single request (optimized)
     * Returns: { inbox, archived, unread, total }
     */
    async getAllCounts() {
        try {
            const response = await apiClient.get('/notifications/counts')
            return response.data
        } catch (error) {
            console.error('Error fetching notification counts:', error)
            throw error
        }
    }

    /**
     * Mark notification as read
     */
    async markAsRead(id) {
        try {
            const response = await apiClient.post(`/notifications/${id}/read`)
            return response.data
        } catch (error) {
            console.error('Error marking notification as read:', error)
            throw error
        }
    }

    /**
     * Mark all notifications as read
     */
    async markAllAsRead() {
        try {
            const response = await apiClient.post('/notifications/mark-all-read')
            return response.data
        } catch (error) {
            console.error('Error marking all notifications as read:', error)
            throw error
        }
    }

    /**
     * Archive notification
     */
    async archive(id) {
        try {
            const response = await apiClient.post(`/notifications/${id}/archive`)
            return response.data
        } catch (error) {
            console.error('Error archiving notification:', error)
            throw error
        }
    }

    /**
     * Unarchive notification (move back to inbox)
     */
    async unarchive(id) {
        try {
            const response = await apiClient.post(`/notifications/${id}/unarchive`)
            return response.data
        } catch (error) {
            console.error('Error unarchiving notification:', error)
            throw error
        }
    }

    /**
     * Delete notification
     */
    async delete(id) {
        try {
            const response = await apiClient.delete(`/notifications/${id}`)
            return response.data
        } catch (error) {
            console.error('Error deleting notification:', error)
            throw error
        }
    }
}

export default new NotificationService()
